import { Field } from 'formik'
import { MdArrowDropDown } from 'react-icons/md'

export default function RamStatusCheckCreate() {
  return (
    <div className="grid items-center grid-cols-12 p-3 lg:auto-rows-min print:p-2 md:gap-1 lg:gap-3 print:gap-2 print:auto-rows-auto">
      {/* COMPROVAR FILTRES / FULARD / CORRONS */}
      <div className="h-8 col-span-12 py-1 mt-5 text-sm print:col-span-3 lg:mt-0 font-ms-semi print:mt-0">
        Comprovar filtres / fulard / corrons:
      </div>

      {/* COMPROVAR DRAP TOBERES / DRAP GOMES / ENCOLADORS / MAQ. COSIR / AGULLES RAM / V.A. */}
      <div className="h-8 col-span-12 py-1 mt-5 text-sm print:col-span-3 lg:mt-0 font-ms-semi print:mt-0">
        Comprovar drap toberes / drap gomes / encoladors / maq. Cosir / agulles ram / V.A.:
      </div>

      {/* OBSERVACIONS */}
      <div className="col-span-12 mt-5 text-sm print:col-span-3 lg:mt-0 lg:col-span-4 xl:col-span-3 font-ms-semi print:mt-0">
        Observacions:
      </div>
      <div className="flex items-center h-8 col-span-12 space-x-2print:col-span-9 lg:col-span-8 xl:col-span-9">
        <Field
          type="text"
          name="RequestArticle.RamStatusCheckObservation"
          className={`w-full h-full px-2 py-1 leading-tight border border-gray-300 rounded-sm appearance-none
                  hover:border-gray-400 focus:border-gray-400 focus:outline-none focus:shadow-outline`}
        />
      </div>
    </div>
  )
}

RamStatusCheckCreate.propTypes = {}
